import React from 'react'

export const Section3 = () => {
  return (
    <div className='container p-3'>
        <div className='row text-center p-3' id='sect3'>
            <div className='col-md-1'></div>
            <div className='col-md-10 mt-3'>
            <h2>Limitless Options</h2>
        <p>Phasellus sed nisi ac dui interdum semper. Etiam consequat fermentum sollicitudin. Fusce vulputate porta faucibus. Vivamus nulla tellus, accumsan non efficitur id, pretium quis ante</p>
        <button className='btn1'>Download Now</button>
            </div>
            <div className='col-md-1'></div>
            <img src='p4.jpg'></img>
        </div>
        
    
    </div>
  )
}
